import { BaseUserRoleDTO } from "../../base/base-user-role-dto.model";
import { PAETEPRoleType } from "../../enum/paetep-role-types.enum";
import { PaetepRoles } from "../../enum/rubric/user-role-names.enum";

export const EXCLUDED_ROLES_FOR_FILTER = ['Translator (en-US)', 'Subscribers', 'Registered Users', 'Unverified Users', 'NTPE', 'NTPE_Supervisor', 'Nontenured',
    // THE FOLLOWING ARE TEMPORARY AND NEED TO BE ADDED BACK IN ONCE WE DO PERMISSIONS ROLE FILTERING
    //'NTPE_Other_Supervisor', 'Sup_Curr_Instruction', 'Sup_Pupil_Services', 'Sup_Spec_Education', 'Sup_Voc_Education', 'CTC_Director', 'Building_Principal'
    'SchoolDistrict_Admin', 'Emergency_Cert', 'Substitute'
];

export const SUPERVISOR_ROLES = ['NTPE_Supervisor', 'NTPE_Other_Supervisor', 'Sup_Curr_Instruction', 'Sup_Pupil_Services', 'Sup_Spec_Education', 'Sup_Voc_Education', 'CTC_Director', 'Building_Principal'];

export const SECONDARY_ROLES: { name: string, type:  PAETEPRoleType}[] = [
    { name: PaetepRoles.EmergencyCertified, type: PAETEPRoleType.Emergency_Cert },
    { name: PaetepRoles.Substitute, type: PAETEPRoleType.Substitute }
];

export class UserRoleHelper {

    public static filterUserRoles(userRoles: BaseUserRoleDTO[] = []) {
        return userRoles.filter(r => !EXCLUDED_ROLES_FOR_FILTER.includes(r?.roleName ?? ''));
    }

    public static isUserroleSupervisor(userRole: BaseUserRoleDTO) {
        return SUPERVISOR_ROLES.includes(userRole?.roleName ?? '');
    }

    public static userRoleAdditionalInformation(userRole: BaseUserRoleDTO) {
        switch (userRole?.roleName) {
            case 'Phys_Occ_Therapist': return 'According to PDE, Physical Therapist/Occupational Therapist (PT/OT) are licensed professionals that do not fall under Act 13.  However, an LEA may choose to evaluate a PT/OT under Act 13.';
            default: return '';
        }
    }

    public static isSecondaryRole(role: PAETEPRoleType | string) {
        return (typeof role === 'string') ?
            SECONDARY_ROLES.map(r => r.name).includes(role) :
            SECONDARY_ROLES.map(r => r.type).includes(role);
    }
}